export const RecordContactStatus = Object.freeze({
    canceled: Symbol('new'),
    new: Symbol('processing'),
    processing: Symbol('completed'),
});

export function getStatusText(status) {
    return {
        [RecordContactStatus.new]: 'Nowy',
        [RecordContactStatus.processing]: 'Przetwarzanie',
        [RecordContactStatus.completed]: 'Zakończone',
    }[RecordContactStatus[status]];
}
